import { groupBy, isEmpty } from 'lodash';

export const getPricesByVariation = (variations: any[]) => {
  const groups: any = {};
  const groupedByVariation = groupBy(variations, 'traveller_composition');
  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (const variation in groupedByVariation) {
    groups[variation] = [];
    groupedByVariation[variation].forEach((trip: any): void => {
      groups[variation].push(trip);
    });
  }

  return groups;
};

export const getVariationPrice = (tripVariation) => {
  const cost = tripVariation.representative_trip_variation_cost;
  const actualPrice = cost ? !isEmpty(cost.cached_converted_overridden_prices.amounts)
    ? cost.cached_converted_overridden_prices.amounts
    : cost.cached_converted_prices.amounts
      ? cost.cached_converted_prices.amounts
      : cost.cached_prices.amounts : { CAD: 0, USD: 0 };

  return actualPrice
}